// import { useState } from "react";
// import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { toastEmitter } from "../utils/utilities";
// import { addPayPalWalletNew } from "../hooks/services/api-services";

// const StripePayment = ({
//   clientSecret,
//   remainingAmount,
//   userData,
//   onSuccess,
//   closeModal,
// }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [loading, setLoading] = useState(false);

//   const handleStripePay = async () => {
//     if (!stripe || !elements) return;

//     setLoading(true);

//     const result = await stripe.confirmPayment({
//       elements,
//       redirect: "if_required",
//     });

//     if (result.error) {
//       toastEmitter("error", result.error.message);
//       setLoading(false);
//       return;
//     }

//     if (result.paymentIntent?.status === "succeeded") {
//       await addPayPalWalletNew({
//         id: userData.id,
//         amount: remainingAmount,
//         orderId: result.paymentIntent.id,
//         payerEmail: userData.email,
//         userType: "CLINICSUBSCRIPTION",
//         paymentMethod: 2,
//       });

//       toastEmitter("success", "Stripe payment successful");
//       onSuccess?.();
//       closeModal?.();
//     }

//     setLoading(false);
//     return;
//   };

//   return (
//     <>
//       <PaymentElement options={{ layout: "tabs" }} />

//       <button
//         className="btn btn-success w-100 mt-3"
//         onClick={handleStripePay}
//         disabled={loading}
//       >
//         {loading ? "Processing..." : "Pay with Stripe"}
//       </button>
//     </>
//   );
// };

// export default StripePayment; 
import { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { toastEmitter } from "../utils/utilities";

const StripePayment = ({ onStripeSuccess,loading  }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isloading, setIsLoading] = useState(false);
  const handleStripePay = async () => {
  if (!stripe || !elements) return;

  setIsLoading(true);

  const result = await stripe.confirmPayment({
    elements,
    redirect: "if_required",
  });

  if (result.error) {
    toastEmitter("error", result.error.message);
    setIsLoading(false);
    return;
  }

  if (result.paymentIntent?.status === "succeeded") {
    onStripeSuccess(result.paymentIntent); 
  }

};

  return (
    <>
   <div className="stripe-payment-wrapper">
  <PaymentElement options={{ layout: "tabs"}} />
</div>
      <button
        className="btn btn-success w-100 mt-3"
        onClick={handleStripePay}
        disabled={loading}
      >
        
        {isloading ? "Processing..." : "Pay with Stripe"}
      </button>
    </>
  );
};

export default StripePayment;
